import styled from "styled-components";
import SudokuIFrame from "./SudokuIFrame";
import pixelBackground1 from "../assets/pixelblu.png"
import pixelBackground2 from "../assets/pixelblu2.png"
import { useState } from "react";
import { IoArrowBack } from "react-icons/io5";

const CardWrapper = styled.div`
    width: 500px;
    aspect-ratio: 1.66;
    position: relative;
    background-image: ${(props) => `url(${props.image})`};
    background-size: 100%;
    border: 4px solid white;
    z-index: 1;
`;

const Card = styled.div`
    width: 500px;
    aspect-ratio: 1.66;
    position: relative;
    background: black;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    
    clip-path: polygon(
        0% 100%, 0% 90%, 7% 90%, 7% 80%, 14% 80%, 14% 70%, 
        21% 70%, 21% 60%, 28% 60%, 28% 50%, 35% 50%, 35% 40%, 
        42% 40%, 42% 30%, 49% 30%, 49% 20%, 56% 20%, 56% 10%, 
        63% 10%, 63% 0%, 100% 0%, 100% 100%
    );

    &::before {
        content: "";
        position: absolute;
        top: -5px;
        left: -5px;
        width: calc(100% + 10px);
        height: calc(100% + 10px);
        background: none;
        border: 4px solid white; 
        clip-path: inherit; 
    }
`

const CardBorder = styled.div`
    position: absolute;
    background: white;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    clip-path: polygon(
        0% 99.5%, 0% 88.5%, 6% 88.5%, 6% 78.5%, 13% 78.5%, 13% 68.5%, 
        20% 68.5%, 20% 58.5%, 27% 58.5%, 27% 48.5%, 34% 48.5%, 34% 38.5%, 
        41% 38.5%, 41% 28.5%, 48% 28.5%, 48% 18.5%, 55% 18.5%, 55% 8.5%, 
        62% 8.5%, 62% 0%, 100% 0%, 100% 100%
    );
`;

const CardTitle = styled.p`
    font-size: ${(props) => props.size}em;
    margin: 35px 12px 0px 0px;
    color: white;
    font-weight: bold;
`

const CardDescription = styled.p`
    margin: 10px 12px 0px 0px;
    max-width: 265px;
    color: white;
    line-height: 19px;
    text-align: justify;
`

const CardButtonContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    margin: 17px;
`

const CardButton = styled.a`
    position: relative;
    width: 180px;
    height: 60px;
    margin: 0px 0px 0px 30px;
    line-height: 60px;
    letter-spacing: 2px;
    text-decoration: none;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
    transition: 0.5s;
    border: 1px solid ${(props) => props.variant === "1" ? "#3a8ec7" : "#007fff"};
    user-select: none;


    @media (hover: hover) and (pointer: fine) {
        &:hover { 
            border: 1px solid transparent;
            background: ${(props) => props.variant === "1" ? "#3a8ec7" : "#007fff"} 
                        url(${(props) => props.variant === "1" ? pixelBackground1 : pixelBackground2});
            transition-delay: 0.8s;
            background-size: 180px;
            animation: animate 0.8s steps(8) forwards;
        }
        &:active {
            background: ${(props) => props.variant === "1" ? "#2a6e9f" : "#005fbf"};
            transition: background 0.001s ease-in-out;
        }
    }

    &:active {
        background: ${(props) => props.variant === "1" ? "#2a6e9f" : "#005fbf"};
        transition: background ease-in-out;
    }

    @keyframes animate {
    0% {
        background-position-y: 0;
    }
    100% {
        background-position-y: -480px;
    }
    }
`

const ReadMore = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: 35% 85%;
    width: 100%;
    height: 100%;
    background: black;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: ${(props) => props.open ? "scale(1)" : "scale(0)"};
    opacity: ${(props) => props.open ? 1 : 0};
    visibility: ${(props) => props.open ? "visible" : "hidden"};
    transition: transform 0.5s ease, opacity 0.5s ease, visibility 0.5s ease;
`;

const ReadMoreTitle = styled.p`
    font-size: 3.4em;
    margin: 5px 0 0 0;
    color: white;
    font-weight: bold;
`

const ReadMoreDescription = styled.p`
    margin: 10px 20px 0 20px;
    color: white;
    line-height: 19px;
    text-align: justify;
`

const BackButton = styled.button`
    position: absolute;
    left: 5px;
    top: 5px;
    background: none;
    border: none;
    color: ${(props) => props.color};
    font-size: 2.5em;
    cursor: pointer;

    &:active{
        color: rgb(73, 76, 156);
    }

    &:hover{
        color: rgb(95, 99, 214);
        transition: color 0.3s ease-in-out;
    }
`

const AppContainer = styled.div`
    display: flex;
    background: rgb(238, 238, 238);
    transform-origin: 50% 50%;
    position: fixed;
    justify-content: center;
    align-items: center;
    width: 60vw;
    height: 60vh;
    border-radius: 30px;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: ${(props) => props.open ? "translate(-50%, -50%) scale(1)" : "translate(-50%, -50%) scale(0)"};
    opacity: ${(props) => props.open ? 1 : 0};
    visibility: ${(props) => props.open ? "visible" : "hidden"};
    transition: transform 0.5s ease, opacity 0.5s ease, visibility 0.5s ease;

    @media (max-width: 768px) {
        width: 95vw;
        height: 80vh;
    }

    z-index: 2;
`

function ProjectCard({title, titleSize, shortDescription, longDescription, image, appName}) {
    const [readMoreOpen, setReadMoreOpen] = useState(false);
    const [appOpen, setAppOpen] = useState(false);

    const getProject = () => {
        switch(appName) {
            case "sudoku":
                return (
                    <AppContainer open={appOpen}>
                        <SudokuIFrame/>
                        <BackButton onClick={() => setAppOpen(!appOpen)} color="black">
                            <IoArrowBack/>
                        </BackButton>
                    </AppContainer>
                );
            case "carRenderer":
                return(
                    <></>   // TODO: Add link to car renderer when project is done (see you in a year)
                );
            default:
                return <></>;
        }
    }
    
    return(
        <>
            <CardWrapper image={image}>
                <CardBorder/>
                    <Card>
                        <CardTitle size={titleSize}>{title}</CardTitle>
                        <CardDescription>{shortDescription}</CardDescription>
                        <CardButtonContainer>
                            <CardButton variant="1" onClick={() => setReadMoreOpen(!readMoreOpen)}>Read more...</CardButton>
                            {appName === "sudoku" &&
                                <CardButton variant="2" onClick={() => setAppOpen(!appOpen)}>Try it!</CardButton>
                            }
                        </CardButtonContainer>
                    </Card>
                <ReadMore open={readMoreOpen}>
                    <BackButton onClick={() => setReadMoreOpen(!readMoreOpen)} color="white">
                        <IoArrowBack/>
                    </BackButton>
                    <ReadMoreTitle>{title}</ReadMoreTitle>
                    <ReadMoreDescription>{longDescription}</ReadMoreDescription>
                </ReadMore>
            </CardWrapper>
            {getProject()}
        </>
    )
}

export default ProjectCard;